import { invitationReadKey, isEnrollmentPage } from '@/utils/promotion-invitation'

export default {
  data() {
    return { invitationUnread: false, invitationRead: false }
  },
  mounted() {
    this.loadInvitationReminder()
  },
  watch: {
    '$route.path'(path) {
      if (isEnrollmentPage(path)) this.readInvitationReminder()
    }
  },
  methods: {
    readInvitationReminder() {
      if (!this.invitationUnread) return
      this.invitationUnread = false
      this.invitationRead = true
      try {
        const key = invitationReadKey(this.$cookies)
        if (key) window.localStorage.setItem(key, '1')
      } catch (error) {
        // Keep the read state for this session if browser storage is unavailable.
      }
    },
    async loadInvitationReminder() {
      try {
        const key = invitationReadKey(this.$cookies)
        if (!key) return
        try {
          this.invitationRead = window.localStorage.getItem(key) === '1'
        } catch (error) {
          // Storage may be disabled by the browser.
        }
        if (this.invitationRead) return
        const regionId = this.$cookies.get('sellerRegionId')
        let skip = 0
        const limit = 100
        while (!this.invitationRead) {
          const { data } = await this.$axios.get('/big-discount-sales', {
            params: { regionId, skip, limit, isExcludeFuture: true }
          })
          const rows = data.data.bigDiscountSales || []
          this.invitationUnread = rows.some(row => row.invitationSkuCount > 0)
          if (this.invitationUnread) {
            if (isEnrollmentPage(this.$route.path)) this.readInvitationReminder()
            return
          }
          skip += rows.length
          if (!rows.length || skip >= data.data.total) return
        }
      } catch (error) {
        // Reminder lookup must not prevent navigation or enrollment.
      }
    }
  }
}
